import { render } from "./BulkBillUpload.vue?vue&type=template&id=15562fca&scoped=true"
import script from "./BulkBillUpload.vue?vue&type=script&lang=js"
export * from "./BulkBillUpload.vue?vue&type=script&lang=js"

import "./BulkBillUpload.vue?vue&type=style&index=0&id=15562fca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15562fca"]])

export default __exports__